import moment from 'moment';
import {
    submitOrderRequest,
    hasPaymentMethod,
    getCurrentOrder,
    getSubmitOrderFlags,
    CREATE_ORDER_REQUEST_FAILED,
    SUBMIT_ORDER,
    SUBMIT_ORDER_REQUEST_SUCCEEDED,
    CREATE_ORDER_REQUEST_SUCCEEDED,
    UPDATE_ORDER_REQUEST_SUCCEEDED,
} from './order.state';
import { createMiddleware } from '../../../shared/redux';
import { updateSubscription, getSubscriptionData } from '../subscription/subscription.state';
import { showErrorToast, showSuccessToast } from '../../../shared/toasts/toasts.state';
import { editSimulation, getRecurrencePayment } from './simulation/simulation.state';
import { closeOrderModal, changeOrderModalStep } from '../interface/interface.state';
import { getUserFeatures } from '../../feature-toggle/feature-toggle.state';
import { updateIntercomSettings } from '../../analytics/intercom/intercom-script-state';
import { getPlan } from '../../pricing/plan/plan.state';
import { getAddonsData } from '../../pricing/addon/addon.state';
import { formatAddonsToIntercom } from '../../analytics/intercom/intercom-script';

const getOrderPrice = action => action.payload.data.price;

export const currentOrderMiddlewares = createMiddleware({
    [SUBMIT_ORDER]: (state, action) => {
        const flags = getSubmitOrderFlags(state);
        if (!flags.hasBillingDetails) {
            return [
                changeOrderModalStep({ billingDetails: true }),
                showErrorToast({ message: 'You are required to provide billing details prior to subscribing.' })];
        }

        const currentOrder = getCurrentOrder(state);
        const recurrencePayment = getRecurrencePayment(state);

        const paymentMethodId = hasPaymentMethod(state)
            ? currentOrder.data.payment.methodId
            : action.payload.paymentMethodId;

        return submitOrderRequest({
            id: currentOrder.data.id,
            paymentIntentId: currentOrder.data.payment.intentId,
            paymentMethodId,
            recurrencePaymentMethod: recurrencePayment,
        });
    },
    [SUBMIT_ORDER_REQUEST_SUCCEEDED]: (state, action) => {
        const { payload } = action;
        const { data } = payload;
        const { subscription, payment } = data;

        const currentSubscription = getSubscriptionData(state);
        const currentPlan = getPlan(state, currentSubscription.planId);
        const newPlan = getPlan(state, subscription.planId);
        const addons = getAddonsData(state);

        const date = moment().format('X');

        const intercomCompanyData = {
            plan: newPlan.name,
            last_plan: currentPlan.name,
            upgrade_plan: true,
            upgrade_plan_date: date,
            monthly_spend: payment.total.amount,
            monthly_spend_currency: payment.total.currency,
            ...formatAddonsToIntercom(addons, subscription.addonIds),
        };

        return [
            updateIntercomSettings({ company: intercomCompanyData }),
            closeOrderModal(),
            updateSubscription({ subscription }),
            getUserFeatures(),
            showSuccessToast({ message: 'Order success paid' }),
        ];
    },
    [CREATE_ORDER_REQUEST_FAILED]: () => [closeOrderModal(), showErrorToast({ message: 'Failed on create order' })],
    [CREATE_ORDER_REQUEST_SUCCEEDED]: (_, action) => editSimulation({
        cycleDate: getOrderPrice(action).cycleDate,
        preventRequest: true,
        planId: getOrderPrice(action).chargesComposition.plan.id,
        addonIds: getOrderPrice(action).chargesComposition.addons
            .map(addon => addon.id),
        seats: getOrderPrice(action).seats,
        investment: getOrderPrice(action).investment.amount,
        total: action.payload.data.total,
        subtotal: action.payload.data.subtotal,
        coupon: getOrderPrice(action).appliedCoupon,
    }),
    [UPDATE_ORDER_REQUEST_SUCCEEDED]: (_, action) => editSimulation({
        cycleDate: getOrderPrice(action).cycleDate,
        preventRequest: true,
        total: action.payload.data.total,
        subtotal: action.payload.data.subtotal,
        investment: getOrderPrice(action).investment.amount,
    }),
});
